var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":_vm.d_src},on:{"error":_vm.setPlaceholder}})}
var staticRenderFns = []

export { render, staticRenderFns }